module.exports = __webpack_public_path__ + "59cb53f8a0a1f096859bc50e011fbc12.MP3";